import {Component, computed, inject} from "@angular/core";
import {CommonModule} from "@angular/common";
import {UserService} from "src/app/services/user.service";

@Component({
    selector: "app-user-avatar",
    standalone: true,
    imports: [CommonModule],
    template: `
        <div class="avatar-circle" [style.background-color]="backgroundColor()">
            <span class="initials">{{ initials() }}</span>
        </div>
    `,
    styles: [
        `
          .avatar-circle {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            font-weight: 500;
          }

          .initials {
            font-size: 24px;
            text-transform: uppercase;
          }
        `,
    ],
})
export class UserAvatarComponent {
    private userService = inject(UserService);
    private colors: string[] = [
        "#1abc9c",
        "#2ecc71",
        "#3498db",
        "#9b59b6",
        "#34495e",
        "#16a085",
        "#27ae60",
        "#2980b9",
        "#8e44ad",
        "#2c3e50",
    ];

    // Computed signal for initials
    readonly initials = computed(() => {
        const firstName = this.userService.user()?.first_name;
        const lastName = this.userService.user()?.last_name;

        if (!firstName && !lastName) return "";

        const firstInitial = firstName ? firstName.charAt(0) : "";
        const lastInitial = lastName ? lastName.charAt(0) : "";

        return (firstInitial + lastInitial).toUpperCase();
    });

    // Computed signal for background color
    readonly backgroundColor = computed(() => {
        const fullName = `${this.userService.user()?.first_name} ${
            this.userService.user()?.last_name
        }`;
        const index = Math.abs(this.hashCode(fullName) % this.colors.length);
        return this.colors[index];
    });

    private hashCode(str: string): number {
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }
        return hash;
    }
}
